<footer id="footer" class="clearfix dark">
    <app-top-footer [showFirstRowFooter]="showFirstRowFooter" [showSecondRowFooter]="showSecondRowFooter" [showContactDetails]="showContactDetails" [showSocialIconsCopyright]="showSocialIconsCopyright"> </app-top-footer>
    <app-sub-footer *ngIf="showWebsiteFooter && isFooterDataLoaded"></app-sub-footer>
</footer>